const convertSeconds = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const hourString = hours > 0 ? `${hours < 10 ? `0${hours}` : hours}` : "";
  const minuteString =
    minutes > 0 ? `${minutes < 10 ? `0${minutes}` : minutes}` : "";
  const secondString =
    remainingSeconds > 0
      ? `${remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds}`
      : "";

  if (hours > 0) {
    return `${hourString}:${minuteString || "00"}${
      secondString && `:${secondString}`
    }`;
  } else if (!hours && minutes > 0) {
    return `${minuteString}${secondString && `:${secondString}`}`;
  }

  return secondString;
};

export default convertSeconds;
